import { guideSteps } from '@/mocks/homeData';

export default function Guide() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-secondary-900">
            <i className="ri-compass-3-fill" /> 使用指引
          </span>
          <h2 className="mt-2 text-2xl font-extrabold text-foreground-950 md:text-4xl">四步逛完 91免费</h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            单页工具型设计，板块分区清晰，按下面几步就能把精选合集与内容包逛明白。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((g, idx) => (
            <div key={g.step} className="relative rounded-2xl border border-background-200 bg-background-50 p-6">
              {idx !== guideSteps.length - 1 && (
                <i className="ri-arrow-right-line absolute right-4 top-1/2 hidden -translate-y-1/2 text-2xl text-background-300 lg:block" />
              )}
              <span className="font-heading text-5xl text-background-300">{g.step}</span>
              <span className="mt-4 flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-xl text-primary-700">
                <i className={g.icon} />
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-950">{g.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{g.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}